import React from "react";

const Home = () => {
  return (
    <div>
      <h1>Welcome to the Colortokes Docs</h1>
      <p>Please navigate to "/docs" to view the API docs</p>
    </div>
  );
};

export default Home;
